import React, { useEffect, useMemo, useState } from 'react';
import { Layout, theme } from 'antd';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../../assets/images/logo+-+openepnet.webp';
import './PublicHeader.css';

const { Header } = Layout;

const isLoggedIn = () => {
  try {
    return Boolean(JSON.parse(localStorage.getItem('userInfo') || 'null')?.token);
  } catch {
    return false;
  }
};

/**
 * Shared NHS-style header for public portal, login, and authenticated app chrome.
 */
const PublicHeader = ({ leading = null, fixed = false }) => {
  const location = useLocation();
  const { token: { colorPrimary } } = theme.useToken();
  const authed = useMemo(isLoggedIn, [location.pathname]);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navLink = (to, label) => {
    const active = location.pathname === to || (to !== '/home' && location.pathname.startsWith(to));
    return (
      <Link to={to} className={active ? 'is-active' : undefined} style={{ fontWeight: active ? 700 : 500 }}>
        {label}
      </Link>
    );
  };

  return (
    <Header
      role="banner"
      className={fixed ? 'public-header public-header--fixed' : 'public-header'}
      style={{ backgroundColor: colorPrimary, '--public-header-bg': colorPrimary }}
    >
      <div className="public-header-inner">
        <div className="public-header-left">
          {leading}
          <Link
            to="/home"
            aria-label="OpenEP|NET home"
            className="public-header-logo"
          >
            <img src={logo} alt="OpenEP|NET" />
          </Link>
        </div>
        <button
          type="button"
          className="public-header-toggle"
          aria-expanded={menuOpen}
          aria-controls="public-header-nav"
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <CloseOutlined /> : <MenuOutlined />}
          <span className="public-header-toggle-label">Menu</span>
        </button>
        <nav
          id="public-header-nav"
          aria-label="Site"
          className={menuOpen ? 'public-header-nav is-open' : 'public-header-nav'}
        >
          {navLink('/home', 'Home')}
          {navLink('/posts', 'Research updates')}
          {authed ? (
            <Link to="/dashboard" className="public-header-cta">Dashboard</Link>
          ) : (
            <Link to="/userlogin" className="public-header-cta">Staff login</Link>
          )}
        </nav>
      </div>
    </Header>
  );
};

export default PublicHeader;
export const PUBLIC_HEADER_HEIGHT = 64;
